import * as endPoints from "../../constants/v2/endPoints";
import * as apiService from "../v2/apiService";

export async function checkMessageCompliance(text, tier, signal = null) {
  return await apiService.apiCall(
    endPoints.CHECK_MESSAGE_COMPLIANCE,
    "POST",
    { text, tier },
    null,
    null,
    null,
    false,
    signal,
  );
}
